import { configureStore } from "@reduxjs/toolkit";
import adminReducer from "../redux/admin/adminSlice";
import categoryreducer from "../redux/category/CategorySlice";
import newsAdminreducer from "../redux/news/NewsSlice";
import reporterreducer from "../redux/reporter/ReporterSlice";
import districtReducer from "../redux/district/districtSlice";

export const store = configureStore({
  reducer: {
    admin: adminReducer,
    category: categoryreducer,
    newsAdmin: newsAdminreducer,
    reporter: reporterreducer,
    districts: districtReducer,
  },
});
